import { ComponentProps } from 'lib/component-props';
import React, { useMemo } from 'react';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import { useArticle } from 'hooks/useArticle';
import { useI18n } from 'next-localization';
import EEPlaceholder from 'components/Sections/EEPlaceholder';
import RelatedBlock from 'components/Pages/ArticleParts/RelatedBlock';

type RelatedCapabilitiesProps = ComponentProps & {
  sidebar?: boolean;
  className?: string;
};

const RelatedHelpPlatform: React.FC<RelatedCapabilitiesProps> = ({
  rendering,
  className,
  sidebar,
}) => {
  const {
    sitecoreContext: { pageEditing },
  } = useSitecoreContext();
  const { config, data } = useArticle('helpArticle', 'helpArticleWildcardConfiguration');
  const { t } = useI18n();
  const items = useMemo(
    () =>
      config?.helpPlatformCards?.filter((helpCard) =>
        data?.helpPlatform?.targetItems
          ?.map((c) => c.id)
          .includes(helpCard.id.replace('-', '').replace('{', '').replace('}', ''))
      ) ?? [],
    [config?.helpPlatformCards, data?.helpPlatform?.targetItems]
  );

  const passThroughProps = {
    rendering,
    title: t('nextSteps'),
    sidebar,
    items,
    className,
    helpArticle: true,
  };

  if (pageEditing) return <EEPlaceholder>RelatedCapabilities Section</EEPlaceholder>;

  if (!config.showRelatedHelpPlatform || items.length === 0) return null;

  return <RelatedBlock {...passThroughProps} />;
};

export default RelatedHelpPlatform;
